
import { supabase } from '@/lib/supabase';

export interface ExistingBotConnectionDetails {
  botName: string;
  accountNumber: string;
  isReversePosition: boolean;
}

export const getExistingBotConnectionDetails = async (
  apiConnectionId: string
): Promise<ExistingBotConnectionDetails | null> => {
  try {
    // Get the bot account that's using this API connection
    const { data: botAccount, error: botAccountError } = await supabase
      .from('bot_accounts')
      .select('bot_id, is_reverse_position')
      .eq('api_connection_id', apiConnectionId)
      .single();

    if (botAccountError || !botAccount) {
      console.error('Error fetching bot account:', botAccountError);
      return null;
    }

    // Get the bot details using the bot_id (which could be shadow bot)
    const { data: bot, error: botError } = await supabase
      .from('bots')
      .select('name, original_bot_id')
      .eq('id', botAccount.bot_id)
      .single();

    if (botError || !bot) {
      console.error('Error fetching bot:', botError);
      return null;
    }

    // Get the trading account number
    const { data: tradingAccount, error: tradingError } = await supabase
      .from('trading_accounts')
      .select('number_account_trading')
      .eq('api_connection_id', apiConnectionId)
      .single();

    if (tradingError || !tradingAccount) {
      console.error('Error fetching trading account:', tradingError);
      return null;
    }

    return {
      botName: bot.name,
      accountNumber: tradingAccount.number_account_trading,
      isReversePosition: botAccount.is_reverse_position || false
    };
  } catch (error) {
    console.error('Error in getExistingBotConnectionDetails:', error);
    return null;
  }
};
